import { TunnelStep } from '../model/tunnel-step-type';
import { ConfigurationComponent } from '../../configuration/configuration.component';
import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { BaseInstallationComponent } from '../common/base-installation/base-installation.component';
import { BaseFundingComponent } from '../common/base-funding/base-funding.component';
import { BaseValidationComponent } from '../common/base-validation/base-validation.component';
import { TunnelDataState } from 'src/app/stores/tunnel/model/tunnel-data-state';
import { BathroomHbmConfigurationData } from 'src/app/stores/tunnel/model/configuration-data/bathroom-hbm-configuration-data';
import { BomDataHelper } from 'src/app/services/helpers/bom-data-helper';
import { MODAL } from 'src/app/services/modal.service';
import { FidelityCardTypeEnum } from 'src/app/services/fidelity/fidelity';
import { environment } from 'src/environments/environment';

/**
 * Étapes du tunnel de vente SDB ByMe/HBM 3D (CONFIG_CONTEXT.BATHROOM) :
 * Conception → Pose → Financement → Validation. La garde d'étape porte sur la BOM HomeByMe.
 */
function isBathroomHbmBomEmpty(stateValue: TunnelDataState): boolean {
  const configuration = stateValue.configurationData.get(CONFIG_CONTEXT.BATHROOM) as
    | BathroomHbmConfigurationData
    | undefined;
  return BomDataHelper.isBomUnavailableForProductList(configuration?.bom);
}

export const BATHROOM_TUNNEL_STEPS: TunnelStep[] = [
  {
    component: ConfigurationComponent,
    context: CONFIG_CONTEXT.BATHROOM,
    title: 'Conception',
  },
  ...(!environment.installationSpecifics.bathroomHbm.disableInstallation
    ? [
        {
          component: BaseInstallationComponent,
          context: CONFIG_CONTEXT.BATHROOM,
          title: 'Pose',
          canPrint: false,
          isDisabled: stateValue => {
            return isBathroomHbmBomEmpty(stateValue);
          },
        },
      ]
    : []),
  {
    component: BaseFundingComponent,
    context: CONFIG_CONTEXT.BATHROOM,
    title: 'Financement',
    canPrint: false,
    readonlyProductList: true,
    isDisabled: (stateValue, featureSettings) => {
      if (!featureSettings.financement) {
        return isBathroomHbmBomEmpty(stateValue);
      }

      return (
        stateValue.currentPricing?.totalWithoutFunding === undefined ||
        (featureSettings.pose &&
          stateValue.currentInstallation?.withInstallation !== false &&
          stateValue.currentInstallation?.more2Years === undefined) ||
        isBathroomHbmBomEmpty(stateValue)
      );
    },
  },
  {
    component: BaseValidationComponent,
    context: CONFIG_CONTEXT.BATHROOM,
    title: 'Validation',
    canPrint: true,
    readonlyProductList: true,
    modalToOpen: MODAL.FIDELITY_ADVERTISMENT,
    skipModalToOpen: (stateValue, featureSettings) => {
      return (
        !featureSettings.fidelity ||
        (stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE &&
          stateValue.currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.AUCUNE0)
      );
    },
    isDisabled: (stateValue, featureSettings) => {
      return (
        (featureSettings.financement
          ? stateValue.currentPricing?.totalWithFunding === undefined ||
            stateValue.currentFunding?.downPayment === undefined
          : stateValue.currentPricing?.totalWithoutFunding === undefined) ||
        (featureSettings.pose &&
          stateValue.currentInstallation?.withInstallation !== false &&
          stateValue.currentInstallation?.more2Years === undefined) ||
        stateValue.fidelityLoading ||
        (featureSettings.financement && stateValue.fundingLoading) ||
        isBathroomHbmBomEmpty(stateValue)
      );
    },
  },
];
